import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Utils } from './../shared/utils';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class AssinaturaService {

  private assinaturaUrl = '/assinaturas';

  constructor(
    private http: Http,
    private _flashMessagesService: FlashMessagesService,
    private utils: Utils
  ) { }

  getMinhasAssinaturas(): Promise<any> {
    let url: string = this.assinaturaUrl + '/minhas';
    return this.http.get(url)
      .toPromise()
      .then(response => response.json().dados as any)
      .catch((error) => this.handleError(error));
  }

  getPreview(id: number): Promise<any> {
    let url: string = this.assinaturaUrl + '/' + id + '/preview';
    return this.http.get(url)
      .toPromise()
      .then(response => response.json().dados as any)
      .catch((error) => this.handleError(error));
  }

  assinar(id: number): Promise<Response> {
    let url: string = this.assinaturaUrl + '/' + id + '/assinar';
    return this.http.post(url, {})
      .toPromise()
      .then(response => this.handleSuccess(response.json()))
      .catch((error) => this.handleError(error));
  }

  iniciarGovBr(id: number): Promise<any> {
    let url: string = this.assinaturaUrl + '/' + id + '/govbr/iniciar';
    return this.http.get(url)
      .toPromise()
      .then(response => response.json().dados as any)
      .catch((error) => this.handleError(error));
  }

  concluirGovBr(id: number, code: string, state: string): Promise<any> {
    let url: string = this.assinaturaUrl + '/' + id + '/govbr/concluir';
    return this.http.post(url, JSON.stringify({ code: code, state: state }))
      .toPromise()
      .then(response => this.handleSuccess(response.json()))
      .catch((error) => this.handleError(error));
  }

  downloadP7sUrl(id: number): string {
    return this.assinaturaUrl + '/' + id + '/p7s/download';
  }

  verificarAssinatura(id: number): Promise<any> {
    let url: string = '/assinatura/' + id + '/verificar';
    return this.http.get(url)
      .toPromise()
      .then(response => response.json().dados as any)
      .catch((error) => this.handleError(error));
  }

  private handleSuccess(resp: any): Promise<any> {
    this.utils.flashMessage(resp.msg, 'success');
    return resp;
  }

  private handleError(error: any): Promise<any> {
    switch (error.status) {
      case 500:
        this.utils.flashMessage('Ocorreu error no servidor, entre em contato com o administrador.', 'danger');
        break;
      case 403:
        if (!Array.isArray(error.json().msg)) {
          this.utils.flashMessage(error.json().msg, 'warning');
        } else {
          for (let msg of error.json().msg) {
            this.utils.flashMessage(msg, 'warning');
          }
        }
        break;
      default:
        this.utils.flashMessage('Ocorreu um error, tente novamente mais tarde.', 'danger');
    }
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/assinaturas/assinatura.service.ts